import styled, { css } from 'styled-components';
import { ITypography } from '../interfaces/typography';
import { defaultTheme } from '../styles/theme/default';

export const Heading3XL = styled.h1<ITypography>(
  ({
    theme = defaultTheme,
    color = 'primary',
    ellipsis = false,
    fontStyle = 'normal',
    isUpperCase = false,
    fontWeight = 'semiBold',
  }) => css`
    ${isUpperCase && { 'text-transform': 'uppercase' }};
    font-family: 'Open Sans', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize[40]};
    color: ${theme.textColor[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh1};
    font-style: ${fontStyle};
    margin: 0;
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const Heading2XL = styled.h2<ITypography>(
  ({
    theme = defaultTheme,
    color = 'primary',
    ellipsis = false,
    fontStyle = 'normal',
    isUpperCase = false,
    fontWeight = 'semiBold',
  }) => css`
    ${isUpperCase && { 'text-transform': 'uppercase' }};
    font-family: 'Open Sans', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize[36]};
    color: ${theme.textColor[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh2};
    font-style: ${fontStyle};
    margin: 0;
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const HeadingXL = styled.h3<ITypography>(
  ({
    theme = defaultTheme,
    color = 'primary',
    ellipsis = false,
    fontStyle = 'normal',
    isUpperCase = false,
    fontWeight = 'semiBold',
  }) => css`
    ${isUpperCase && { 'text-transform': 'uppercase' }};
    font-family: 'Open Sans', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize[32]};
    color: ${theme.textColor[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh3};
    font-style: ${fontStyle};
    margin: 0;
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const HeadingL = styled.h4<ITypography>(
  ({
    theme = defaultTheme,
    color = 'primary',
    ellipsis = false,
    fontStyle = 'normal',
    isUpperCase = false,
    fontWeight = 'semiBold',
  }) => css`
    ${isUpperCase && { 'text-transform': 'uppercase' }};
    font-family: 'Open Sans', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize[24]};
    color: ${theme.textColor[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh4};
    font-style: ${fontStyle};
    margin: 0;
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const HeadingM = styled.h5<ITypography>(
  ({
    theme = defaultTheme,
    color = 'primary',
    ellipsis = false,
    fontStyle = 'normal',
    isUpperCase = false,
    fontWeight = 'semiBold',
  }) => css`
    ${isUpperCase && { 'text-transform': 'uppercase' }};
    font-family: 'Open Sans', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize[20]};
    color: ${theme.textColor[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh5};
    font-style: ${fontStyle};
    margin: 0;
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const HeadingS = styled.h6<ITypography>(
  ({
    theme = defaultTheme,
    color = 'primary',
    ellipsis = false,
    fontStyle = 'normal',
    isUpperCase = false,
    fontWeight = 'semiBold',
  }) => css`
    ${isUpperCase && { 'text-transform': 'uppercase' }};
    font-family: 'Open Sans', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize[18]};
    color: ${theme.textColor[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh6};
    font-style: ${fontStyle};
    margin: 0;
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const HeadingXS = styled.span<ITypography>(
  ({
    theme = defaultTheme,
    color = 'primary',
    ellipsis = false,
    fontStyle = 'normal',
    isUpperCase = false,
    fontWeight = 'semiBold',
  }) => css`
    ${isUpperCase && { 'text-transform': 'uppercase' }};
    font-family: 'Open Sans', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize[16]};
    color: ${theme.textColor[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh7};
    font-style: ${fontStyle};
    margin: 0;
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const BodyXL = styled.p<ITypography>(
  ({
    theme = defaultTheme,
    color = 'primary',
    ellipsis = false,
    fontStyle = 'normal',
    isUpperCase = false,
    fontWeight = 'regular',
  }) => css`
    ${isUpperCase && { 'text-transform': 'uppercase' }};
    font-family: 'Open Sans', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize[18]};
    color: ${theme.textColor[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh3};
    font-style: ${fontStyle};
    margin: 0;
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const BodyL = styled.p<ITypography>(
  ({
    theme = defaultTheme,
    color = 'primary',
    ellipsis = false,
    fontStyle = 'normal',
    isUpperCase = false,
    fontWeight = 'regular',
  }) => css`
    ${isUpperCase && { 'text-transform': 'uppercase' }};
    font-family: 'Open Sans', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize[16]};
    color: ${theme.textColor[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh3};
    font-style: ${fontStyle};
    margin: 0;
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const BodyM = styled.p<ITypography>(
  ({
    theme = defaultTheme,
    color = 'primary',
    ellipsis = false,
    fontStyle = 'normal',
    isUpperCase = false,
    fontWeight = 'regular',
  }) => css`
    ${isUpperCase && { 'text-transform': 'uppercase' }};
    font-family: 'Open Sans', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize[14]};
    color: ${theme.textColor[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh4};
    font-style: ${fontStyle};
    margin: 0;
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const BodyMSemiBold = styled.p<ITypography>(
  ({
    theme = defaultTheme,
    color = 'primary',
    ellipsis = false,
    fontStyle = 'normal',
    isUpperCase = false,
    fontWeight = 'semiBold',
  }) => css`
    ${isUpperCase && { 'text-transform': 'uppercase' }};
    font-family: 'Open Sans', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize[14]};
    color: ${theme.textColor[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh4};
    font-style: ${fontStyle};
    margin: 0;
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const BodyS = styled.p<ITypography>(
  ({
    theme = defaultTheme,
    color = 'primary',
    ellipsis = false,
    fontStyle = 'normal',
    isUpperCase = false,
    fontWeight = 'regular',
  }) => css`
    ${isUpperCase && { 'text-transform': 'uppercase' }};
    font-family: 'Open Sans', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize[12]};
    color: ${theme.textColor[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh5};
    font-style: ${fontStyle};
    margin: 0;
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const BodySSemiBold = styled.p<ITypography>(
  ({
    theme = defaultTheme,
    color = 'primary',
    ellipsis = false,
    fontStyle = 'normal',
    isUpperCase = false,
    fontWeight = 'semiBold',
    textDecoration,
  }) => css`
    ${isUpperCase && { 'text-transform': 'uppercase' }};
    font-family: 'Open Sans', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize[12]};
    color: ${theme.textColor[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh5};
    font-style: ${fontStyle};
    margin: 0;
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
    ${textDecoration && { 'text-decoration': textDecoration }};
  `
);

export const BodyXS = styled.p<ITypography>(
  ({
    theme = defaultTheme,
    color = 'primary',
    ellipsis = false,
    fontStyle = 'normal',
    isUpperCase = false,
    fontWeight = 'regular',
  }) => css`
    ${isUpperCase && { 'text-transform': 'uppercase' }};
    font-family: 'Open Sans', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize[11]};
    color: ${theme.textColor[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh6};
    font-style: ${fontStyle};
    margin: 0;
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const BodyXSSemiBold = styled.p<ITypography>(
  ({
    theme = defaultTheme,
    color = 'primary',
    ellipsis = false,
    fontStyle = 'normal',
    isUpperCase = false,
    fontWeight = 'semiBold',
  }) => css`
    ${isUpperCase && { 'text-transform': 'uppercase' }};
    font-family: 'Open Sans', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize[11]};
    color: ${theme.textColor[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh6};
    font-style: ${fontStyle};
    margin: 0;
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const CaptionS = styled.p<ITypography>(
  ({
    theme = defaultTheme,
    color = 'primary',
    ellipsis = false,
    fontStyle = 'normal',
    isUpperCase = true,
    fontWeight = 'regular',
  }) => css`
    ${isUpperCase && { 'text-transform': 'uppercase' }};
    font-family: 'Open Sans', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize[12]};
    color: ${theme.textColor[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh6};
    font-style: ${fontStyle};
    margin: 0;
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);

export const CaptionXS = styled.p<ITypography>(
  ({
    theme = defaultTheme,
    color = 'primary',
    ellipsis = false,
    fontStyle = 'normal',
    isUpperCase = true,
    fontWeight = 'regular',
  }) => css`
    ${isUpperCase && { 'text-transform': 'uppercase' }};
    font-family: 'Open Sans', sans-serif;
    font-weight: ${theme.fontWeight[fontWeight]};
    font-size: ${theme.fontSize[10]};
    color: ${theme.textColor[color]};
    letter-spacing: 0;
    line-height: ${theme.lineHeight.lh6};
    font-style: ${fontStyle};
    margin: 0;
    ${ellipsis && { 'white-space': 'nowrap' }};
    ${ellipsis && { overflow: 'hidden' }};
    ${ellipsis && { 'text-overflow': 'ellipsis' }};
  `
);
